(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const imgContainer_1 = document.getElementById('imgContainer_1');
  const img_1 = document.getElementById('img_1');
  const icon_1 = document.getElementById('icon_1');
  const img_box_1 = document.getElementById('img_box_1');
  const img_mask1 = document.getElementById('img-mask1');

  const imgContainer_3 = document.getElementById('imgContainer_3');
  const img_3 = document.getElementById('img_3');
  const icon_3 = document.getElementById('icon_3');
  const img_mask3 = document.getElementById('img-mask3');

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;
  var SavaButton = true;



  $(document).ready(function() {
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    // const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    const emailGet = document.querySelector('.email__get')
    const emailNumber = document.querySelector('#email')
    const isacc = document.querySelector('#isacc')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    let flag = true
    if(emailGet){
      emailGet.addEventListener('click',function() {
        if(!emailNumber.value){
          error_fun('email_required', 'error_text')
          return
        }else{
          error_fun('', 'error_text')
        }

        let data = {
          email: emailNumber.value,
        }
        if(flag) {
          flag = false
          $.ajax({
          url: api_url + 'bshop/contact/emailcode',
          type: 'post',
          data,
          success: function(res) {
            console.log(res)
            if(res.code == 0){
              // form.reset();
              emailGet.classList.add('cursor_no')
              let time = 60
              let countdownInterval = setInterval(() => {
                if(time <= 0) {
                  clearInterval(countdownInterval)
                  emailGet.classList.remove('cursor_no')
                  let textContent = get_code_text()
                  emailGet.textContent = textContent ? textContent : 'Get Code'
                  time = 60
                  flag = true
                } else {
                  time--
                  emailGet.textContent = time + 's'
                }
              }, 1000);
            }else{
              flag = true
              error_fun(res, 'error_fun')
            }
          },
          error: function(xhr, status, error) {
            flag = true
            error_fun(error, 'error_fun')
            // form.reset();
          }
        })
        }
      })
    }
    
    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          // dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            // const li = document.createElement("li")
            // li.innerHTML =  `
            //   <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
            //   <span class="ls-select__option-code">${data[i].iso_code}</span>
            // `
            // if(i === 0) {
            //   li.classList.add('select_li')
            // }
            // li.addEventListener('click', function() {
            //   dropdownText.value = `+${data[i].call_prefix}`
            //   dropdownMenu.style.display = 'none'
            //   dropdownIcon.classList.remove('is__reverse')
            //   const prefixs = document.querySelectorAll('.dropdown-menu >li')
            //   removeClass(prefixs,'select_li')
            //   li.classList.add('select_li')
            // })
            // dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              // dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              console.log(country_id)
              console.log(country_iso_code)
              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              // dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }

    $('#contact-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const rawFormData = new FormData(this);
      const formData = new FormData(); // 用于存放非空字段
      // 只添加非空、非纯空格字段
      for (let [key, value] of rawFormData.entries()) {
        if (typeof value === 'string' && value.trim() !== '') {
          formData.append(key, value.trim());
        } else if (value instanceof File && value.name) {
          // 保留有效文件（非空文件名）
          formData.append(key, value);
        }
      }
      let isaccValue = isacc.checked
      formData.set('isacc', isaccValue)
      
      if(CustomerEmail){
        formData.set('email', CustomerEmail)
      }
      console.log(CustomerID);
      console.log(CustomerEmail);
      
      let product_id = get_params('products_id')
      let product_name = get_params('products_name')
      let variant = get_params('variant')
      let color = get_params('color')
      let quantity = get_params('quantity')

      if(product_id){
        formData.set('product_id', product_id)
      }
      if(product_name){
        formData.set('product_name', product_name)
      }
      if(variant){
        formData.set('variant', variant)
      }
      if(color){
        formData.set('color', color)
      }
      if(quantity){
        formData.set('quantity', quantity)
      }

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/contact/add',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            contact_click_set_fun(2)
            startCountdown(initial_seconds);
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact_our_platform"] && !Shopify.designMode) return;
  try {
    
  $(function(){

    //打开环信客服
    let huanxin_customer_service = function(){
      window.easemobim = window.easemobim || {};
      easemobim.config = {
        hide: true,
        autoConnect: false,
        configId: '5c8b614f-8d90-4060-88f1-673d508301d5',
        //打开
        onopen: function () {},
        //收起
        onclose: function () {},
      }
      easemobim.bind({configId: "5c8b614f-8d90-4060-88f1-673d508301d5"})
    }

    $('.Email_Us').on('click', function () {
      console.log(1)
      var el = document.createElement("a");
			document.body.appendChild(el);
			el.href = "mailto:B2Bmarketing@tozostore.com";
			el.click();
			document.body.removeChild(el);
    })
    $('.Social_media').on('click', function () {
      console.log(2)
    })
    // $('.Live_Chat').on('click', function () {
    //   console.log(3)
    //   huanxin_customer_service()
    // })
    $('.Call_Us').on('click', function () {
      console.log(4)
    })

    

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["historical_event"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    // 时间轴
    var timerNum = 0;
    var width = $('.timer-scale-cont')[0].offsetWidth;
    var space = width + 20; // 移动间距
    var length = $('.timer-scale-cont').length, numL;
    
    var scaleHeight = $('.timer-scale')[0].offsetHeight;
    let timer_shaft = document.getElementById("timer-shaft")


    // 绑定点击事件
    let Show_more_text = document.getElementById("Show_more_text")
    // 设置初始状态为收缩
    var isExpanded = true;
    set_height()
    Show_more_text.addEventListener('click', function() {
      set_height()
    });
    
    function set_height(){
      // 切换展开收缩状态
      isExpanded = !isExpanded;
      // 根据状态设置内容的高度和按钮的文本
      if (isExpanded) {
        timer_shaft.style.height = scaleHeight + 'px'
        Show_more_text.innerHTML = get_btn_text('Pack_Up')
        timer_shaft.style.transition = 'height 0.5s ease 0s';
      } else {
        timer_shaft.style.height = 400 + 'px'
        Show_more_text.innerHTML = get_btn_text('Show_More')
        timer_shaft.style.transition = 'height 0.5s ease 0s';
      }
    }

    // 向上取整,有小数就整数部分加1
    let remainder = Math.ceil(window.screen.width/width)
    numL = remainder-1
    // 分辨率
    if(window.screen.width > 1280) {
      // numL = length - 4
      numL = length - 3
    } else if(window.screen.width < 1200 && window.screen.width > 769) {
      // numL = length - 5
      numL = length - 2
    } else if(window.screen.width < 769 && window.screen.width > 500) {
      // numL = length - 6
      numL = length - 1
    } else if(window.screen.width < 500) {
      // numL = length - 7
      numL = length
    }
    
    // 左滑
    var let_sliding = function(){
      if(timerNum > 0) {
        timerNum -= 1;
        moveL(timerNum, numL)
      }
      tags(timerNum);
    }
    // 右滑
    var right_sliding = function(){
      if(timerNum < length - 1) {
        timerNum += 1;
        tags(timerNum);
      }
      moveL(timerNum, numL)
    }
    // 定时事件
    var time_fun = function(){
      if(timerNum == length - 1){
        timerNum = 0;
        tags(timerNum);
      }else{
        if(timerNum < length - 1) {
          timerNum += 1;
          tags(timerNum);
        }
      }
      moveL(timerNum, numL)
    }
    //定时器
    let time_num = 3000
    var time = setInterval(time_fun, time_num) //time_fun是你的函数
    
    var a1,a2
    let slide_fun = function(){
      clearInterval(time)//清除定时器
      if(a1>a2){
        // let_sliding()
        console.log("左滑啊")
      }
      if(a1<a2){
        right_sliding()
        console.log("右滑啊")
      }
      setTimeout(()=>{
        time = setInterval(time_fun, time_num)//重新开始定时器
      },3000)
    }


    // 鼠标移入容器内停止自动
    $(".timer-shaft-box").mouseover(function(){
      clearInterval(time)//清除定时器
    }).mouseout(function(){
      time = setInterval(time_fun, time_num)//重新开始定时器
    }).mousedown(function(e){
      a1=e.screenX;
      // slide_fun()
    }).mouseup(function(e){
      a2=e.screenX;
      // slide_fun()
    });
    
    // 点击选中事件
    var click_fun = function(that,index){
      $(that).on('click', function () {
        timerNum = index;
        moveL(timerNum, numL)
        tags(timerNum);
      })
    }
    
    // 点击左侧
    $('.timer-left').on('click', function () {
      let_sliding()
    })
    // 点击右侧
    $('.timer-right').on('click', function () {
      right_sliding()
    })
    // 点击年
    $('.time-circle').each(function (index) {
      let that = this
      click_fun(that,index)
    })
    // 盒子
    $('.timer-scale-cont').each(function (index) {
      let that = this
      click_fun(that,index)
    })
    
    function tags(num){
      $('.timer-scale-cont').eq(num).addClass('hov').siblings().removeClass('hov');
      $('.shaft-detail-cont').eq(num).show().siblings().hide();
    }
    function moveL(num, len) {
      if (num < len) {
        moveLeft = -num * space;
        $('.timer-scale').animate({left:moveLeft}, 700);
      }
    }
    
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__contact-form"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  // console.log(api_url)

  const imgContainer_1 = document.getElementById('imgContainer_1');
  const img_1 = document.getElementById('img_1');
  const icon_1 = document.getElementById('icon_1');
  const img_box_1 = document.getElementById('img_box_1');
  const img_mask1 = document.getElementById('img-mask1');

  const imgContainer_3 = document.getElementById('imgContainer_3');
  const img_3 = document.getElementById('img_3');
  const icon_3 = document.getElementById('icon_3');
  const img_mask3 = document.getElementById('img-mask3');

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;

  
  const fileInput = $('#fileInput')
  const fileText = document.getElementById('input__text')
  const form = $('#my-form')[0]
  fileInput[0].addEventListener('change', function() {
    const curFiles = fileInput[0].files
    let file = curFiles[0]
    if(curFiles.length > 0) {
      var fileSize = file.size
      var size = fileSize / 1024
      if (size > 10000) {
        // showMessage('warning','Attachments must not be larger than 10M')
        api_err.innerHTML = 'Attachments must not be larger than 10M'
        return
      }
      // 先用type验证，如果没有type就用文件后缀名验证
      const types = ['application/rtf', 'text/rtf', 'application/msword', 'application/pdf', 'application/x-rar-compressed', 'application/zip', 'image/png', 'image/jpeg', 'image/gif']
      if (file.type && types.indexOf(file.type) === -1) {
        // showMessage('error','File type error')
        api_err.innerHTML = 'File type error'
        return
      } else {
        const arr = file.name.match(/\.([a-zA-Z]+)$/)
        if (arr) {
          const ext = arr[1]
          const extArr = ['rtf', 'doc', 'pdf', 'zip', 'rar', 'png', 'jpeg', 'jpg', 'gif']
          if (extArr.indexOf(ext) === -1) {
            api_err.innerHTML = 'File type error'
            // showMessage('error','File type error')
            return 
          }
        }
      }
      api_err.innerHTML = ''
      if(fileText){
        fileText.setAttribute("placeholder",curFiles[0].name);
        // fileText.value = fileInput[0].files[0] ? fileInput[0].files[0] : ''
      }
    }
    // showMessage('success','Request successful')
  })

  $(document).ready(function() {
    const jsCustomContactForm = document.getElementById('MainContent')
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#product_name')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    const emailNumber = document.querySelector('#email')

    
    if(jsCustomContactForm){
      jsCustomContactForm.addEventListener('click', function() {
        if(dropdownMenu_country){
          dropdownMenu_country.style.display = 'none'
        }
      });
    }
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      // 阻止事件冒泡到父元素
      event.stopPropagation();
      get_country_list()
    })

    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }
    
    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    let product_list = [
      {
        id: 1,
        name: "Golden X1 Wireless Earbuds",
      },
      {
        id: 21,
        name: "T6 Wireless Earbuds",
      },
      {
        id: 3,
        name: "T10 Wireless Earbuds",
      },
      {
        id: 4,
        name: "NC9 Wireless Earbuds",
      },
      {
        id: 5,
        name: "PA1 Bluetooth Speaker",
      },
      {
        id: 6,
        name: "Smart Watch",
      },
      {
        id: 7,
        name: "Wireless Charger",
      },
      {
        id: 8,
        name: "Wall Chargers",
      },
      {
        id: 9,
        name: "Power Bank",
      },
      {
        id: 10,
        name: "Others",
      }
    ]
    for (let i = 0; i < product_list.length; i++) {
      const div = document.createElement("div")
      div.innerHTML = `<span class="ls-select__option-prefix">${product_list[i].name}</span>`
      if(i === 0) {
        div.classList.add('select_li')
      }
      div.addEventListener('click', function() {
        dropdownText_country.value = `${product_list[i].name}`
        dropdownMenu_country.style.display = 'none'
        const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
        removeClass(prefixs,'select_li')
        div.classList.add('select_li')
      })
      dropdownMenu_country.appendChild(div)
    }

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }

    $('#warranty-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      
      let file = fileInput[0].files[0] ? fileInput[0].files[0] : ''
      if(file){
        formData.set('file', file)
      }

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'contactform',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 1){
            click_set_fun(2)
            // 开始倒计时
            startCountdown(initial_seconds);
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__recommend_awards"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // 初始化轮播函数
    function initCarousel() {
      const isMobile = $(window).width() <= 768;
      
      // 销毁现有轮播实例（如果存在）
      if ($('.awards-slider').hasClass('slick-initialized')) {
        $('.awards-slider').slick('unslick');
      }
      
      if ($('.awards-for').hasClass('slick-initialized')) {
        $('.awards-for').slick('unslick');
      }
      
      // 配置轮播选项
      const sliderOptions = {
        slidesToShow: isMobile ? 3 : 7,
        slidesToScroll: 1,
        asNavFor: '.awards-for',
        autoplay: isMobile, // 仅在移动端自动播放
        arrows: false,
        autoplaySpeed: 2000,
        centerMode: true,
        infinite: true,
        centerPadding: 0,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 3,
              centerPadding: 0
            }
          }
        ]
      };
      
      const forOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: isMobile, // 仅在移动端自动播放
        autoplaySpeed: 2000,
        arrows: false,
        infinite: true,
        fade: true,
        asNavFor: '.awards-slider',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: 0,
              slidesToShow: 1
            }
          }
        ]
      };
      
      // 初始化轮播
      $('.awards-slider').slick(sliderOptions);
      $('.awards-for').slick(forOptions);
    }
    
    // 初始加载时初始化轮播
    initCarousel();
    
    // 窗口大小变化时重新初始化轮播
    $(window).on('resize', function() {
      initCarousel();
    });
    
    // 点击轮播图中的图片时滑动到中心位置
    $('.awards-slider').on('click', '.slick-slide', function() {
      var clickedIndex = $(this).data('slick-index');
      // 确定滑动方向 // 解决负数时滑动没有效果
      if (clickedIndex < -1) {
        let index = $('.awards-slider').slick('getSlick').slideCount + clickedIndex;
        $('.awards-slider').slick('slickGoTo', index, true, 3000);
      } else {
        $('.awards-slider').slick('slickGoTo', clickedIndex);
      }
    });
    
    // 检测User-Agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 判断是移动端还是PC端
    if (!isMobile) {
      // PC端
      // 鼠标移动到轮播图上时停止自动滑动
      $('.awards-slider, .awards-for, .section_recommend').hover(
        function() {
          $('.awards-slider, .awards-for').slick('slickPause');
        },
        function() {
          $('.awards-slider, .awards-for').slick('slickPlay');
        }
      );
    }
    
    // 允许左右拖动切换C位的图
    $('.awards-for').on('mousedown', function() {
      $('.awards-slider').slick('slickPause');
    }).on('mouseup', function() {
      $('.awards-slider').slick('slickPlay');
    });
    
    // 移动端手势点击滑动和禁止
    $('.awards-slider').on('touchstart', function() {
      $('.awards-slider').slick('slickPause');
    }).on('touchend', function() {
      $('.awards-slider').slick('slickPlay');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user_agent_application"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Submit_text = document.getElementById('Submit_text');
  const Next_img = document.getElementById('Next_img');
  const step2Btn = document.getElementById('step2Btn');
  var SavaButton = true;

  // 分步显示逻辑
  // let stepFun = function(step){
  //   if(step == 'additional_information'){
  //     // 切换到第二步前验证第一步必填项
  //     // const requiredFields = [
  //     //   document.getElementById('register_confirm_password'),
  //     //   document.getElementById('register_password'),
  //     //   document.getElementById('register_code'),
  //     //   document.getElementById('contact_email'),
  //     // ];
      
  //     // let isValid = true;
  //     // requiredFields.forEach(field => {
  //     //   if (!field.checkValidity()) {
  //     //     field.reportValidity();
  //     //     field.focus();
  //     //     isValid = false;
  //     //   }
  //     // });
      
  //     // if (!isValid) return;
      
  //     // basic_information.style.display = 'none'
  //     // additional_information.style.display = 'block'
  //     step2Btn.style.display = 'block'
  //   }
  // }

  // stepFun('additional_information')

  $(document).ready(function() {
    // const emailGet = document.querySelector('.email__get')
    // const emailNumber = document.querySelector('#contact_email')
    // const isacc = document.querySelector('#isacc')
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    // const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })  
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    // let flag = true
    // if(emailGet){
    //   emailGet.addEventListener('click',function() {
    //     if(!emailNumber.value){
    //       error_fun('email_required', 'error_text')
    //       emailNumber.focus(); // 聚焦到邮箱输入框
    //       return
    //     }else if (!emailNumber.checkValidity()) {
    //       emailNumber.reportValidity();
    //       emailNumber.focus();
    //       return;
    //     }else{
    //       error_fun('', 'error_text')
    //     }

    //     let data = {
    //       email: emailNumber.value,
    //     }
    //     if(flag) {
    //       flag = false
    //       $.ajax({
    //       url: api_url + 'bshop/checkregister',
    //       type: 'post',
    //       data,
    //       success: function(res) {
    //         console.log(res)
    //         if(res.code == 0){
    //           flag = true
    //           if(res.data.is_exist == 0){
    //             post_error_fun('', 'error_text')
    //             postemailcode(data)
    //           }else{
    //             post_error_fun('Registered', '')
    //           }
    //         }else{
    //           flag = true
    //           post_error_fun(res, 'error_fun')
    //         }
    //       },
    //       error: function(xhr, status, error) {
    //         flag = true
    //         post_error_fun(error, 'error_fun')
    //         // form.reset();
    //       }
    //     })
    //     }
    //   })
    // }

    // 获取验证码
    function registeremailcode(data){
      $.ajax({
        url: api_url + 'bshop/registeremailcode',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 0){
            emailGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
            if(time <= 0) {
              clearInterval(countdownInterval)
              emailGet.classList.remove('cursor_no')
              let textContent = get_code_text()
                emailGet.textContent = textContent ? textContent : 'Get Code'
                time = 60
              } else {
                time--
                emailGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            post_error_fun(res, 'error_fun')
          }
          },
        error: function(xhr, status, error) {
          post_error_fun(error, 'error_fun')
        }
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          countryList = data
          // dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            // const li = document.createElement("li")
            // li.innerHTML =  `
            //   <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
            //   <span class="ls-select__option-code">${data[i].iso_code}</span>
            // `
            // if(i === 0) {
            //   li.classList.add('select_li')
            // }
            // li.addEventListener('click', function() {
            //   dropdownText.value = `+${data[i].call_prefix}`
            //   dropdownMenu.style.display = 'none'
            //   dropdownIcon.classList.remove('is__reverse')
            //   const prefixs = document.querySelectorAll('.dropdown-menu >li')
            //   removeClass(prefixs,'select_li')
            //   li.classList.add('select_li')
            // })
            // dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              // dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              console.log(country_id)
              console.log(country_iso_code)
              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              // dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            post_error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        post_error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    function form_loding(button, type){
      if(button == 'Submit'){
        if(type == 'text'){
          SavaButton = true
          Next_img.style.display = 'none'
          Submit_text.style.display = 'block'
        }else{
          SavaButton = false
          Next_img.style.display = 'block'
          Submit_text.style.display = 'none'
        }
      }
    }
    
    // let product_id = get_params('products_id')
    function get_params(name){
      // 获取当前URL的查询参数
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";  
    }

    const agent_application_form = document.querySelector('.agent_application_form');
    let radioName = "business_type"
    const errorEl = agent_application_form.querySelector('.radio-error');
    // 3. 监听单选框的点击，一旦选中就立刻隐藏提示
    agent_application_form.querySelectorAll(`input[name="${radioName}"]`).forEach(radio => {
      radio.addEventListener('change', function() {
        errorEl.style.display = 'none';
      });
    });

    $('#agent_application_form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      // post_click_set_fun(2)
      // return

      // 验证所有必填字段
      const requiredFields = [
        // document.getElementById('register_confirm_password'),
        // document.getElementById('register_password'),
        // document.getElementById('register_code'),
        document.getElementById('contact_email'),
        document.getElementById('company_name'),
        document.getElementById('country'),
        document.getElementById('customer_type'),
        // document.getElementById('contact_person'),
        // document.getElementById('isacc')
      ];
      
      let isValid = true;
      requiredFields.forEach(field => {
        console.log(field)
        if (!field.checkValidity()) {
          field.reportValidity();
          field.focus();
          isValid = false;
          return false; // 跳出循环
        }
      });

      const business_type_if_selected = agent_application_form.querySelector(`input[name="${radioName}"]:checked`);
      // 检查这组单选框有没有被选中
      if (!business_type_if_selected) {
        // 没选,阻止提交
        event.preventDefault();
        errorEl.style.display = 'block';
        isValid = false;
      } else {
        // 选了,隐藏提示
        errorEl.style.display = 'none';
        isValid = true;
      }
      
      if (!isValid) return;

      const formData = new FormData(this)

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }

      // 1. 处理 business_type：未选择时删除该字段（单选按钮未选中时 FormData 中值为空）
      // const businessTypeChecked = document.querySelector('input[name="business_type"]:checked');
      // if (!businessTypeChecked) {
      //   formData.delete('business_type'); // 未选择则删除字段，不提交
      // }

      // // 2. 强制过滤 platform_name 空值：无论任何情况，空值就删除
      // const platformNameVal = formData.get('platform_name')?.toString().trim() || '';
      // if (platformNameVal === '') {
      //   formData.delete('platform_name');
      // }
      // // 2. 强制过滤 remark 空值：无论任何情况，空值就删除
      // const reasonToCooperateVal = formData.get('remark')?.toString().trim() || '';
      // if (reasonToCooperateVal === '') {
      //   formData.delete('remark');
      // }

      // 3. 通用过滤：所有字段的空值（兼容其他非必填字段）
      for (let [key, value] of formData.entries()) {
        // 排除 isacc（布尔值，false 也需要提交）
        if (key === 'isacc') continue;
        
        // 空字符串/全空格/null/undefined 都删除
        const strVal = value?.toString().trim() || '';
        if (strVal === '') {
          formData.delete(key);
        }
      }

      console.log(SavaButton)
      if(!SavaButton){ return }
      form_loding('Submit', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/contact/saleagent/add',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Submit', 'text')
          if(res.code == 0){
            post_click_set_fun(2)
          }else{
            post_error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Submit', 'text')
          post_error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user_forgot_password"] && !Shopify.designMode) return;
  try {
    
  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;
  var SavaButton = true;

  $(document).ready(function() {
    const emailGet = document.querySelector('.email__get')
    const emailNumber = document.querySelector('#email')
    const isacc = document.querySelector('#isacc')
    

    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    let flag = true
    if(emailGet){
      emailGet.addEventListener('click',function() {
        if(!emailNumber.value){
          error_fun('email_required', 'error_text')
          return
        }else{
          error_fun('', 'error_text')
        }

        let data = {
          email: emailNumber.value,
        }
        if(flag) {
          flag = false
          $.ajax({
          url: api_url + 'bshop/forgetemailcode',
          type: 'post',
          data,
          success: function(res) {
            console.log(res)
            if(res.code == 0){
              // form.reset();
              emailGet.classList.add('cursor_no')
              let time = 60
              let countdownInterval = setInterval(() => {
                if(time <= 0) {
                  clearInterval(countdownInterval)
                  emailGet.classList.remove('cursor_no')
                  let textContent = get_code_text()
                  emailGet.textContent = textContent ? textContent : 'Get Code'
                  time = 60
                  flag = true
                } else {
                  time--
                  emailGet.textContent = time + 's'
                }
              }, 1000);
            }else{
              flag = true
              error_fun(res, 'error_fun')
            }
          },
          error: function(xhr, status, error) {
            flag = true
            error_fun(error, 'error_fun')
            // form.reset();
          }
        })
        }
      })
    }

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }
    
    // let product_id = get_params('products_id')
    function get_params(name){
      // 获取当前URL的查询参数
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";  
    }

    $('#forgot-password-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/forgetpwd',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            forgot_click_set_fun(2)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user_information_edit"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;
  var SavaButton = true;



  $(document).ready(function() {

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }

    // 用户信息
    function get_userinfo(redirect_url){
      const emailNumber = document.querySelector('#email')
      let data = {
        email: emailNumber.value,
      }
      $.ajax({
        url: api_url + 'bshop/userinfo',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 0){
            let userinfo = res.data ? JSON.stringify(res.data) : ''
            localStorage.setItem('userinfo', userinfo);
            // 从localStorage中获取
            const storedUserInfo = localStorage.getItem('userinfo');
            // 转为对象（如果存储的不是空字符串）
            const userData = storedUserInfo ? JSON.parse(storedUserInfo) : null;
            if(redirect_url){
              window.location.href = redirect_url; // 同步shopfiy登录态
            }else{
              callback()
            }
            console.log(userData)
          }else{
            error_fun(res, 'error_fun')
          }
          },
        error: function(xhr, status, error) {
          error_fun(error, 'error_fun')
        }
      })
    }

    $('#user-information-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      const redirect_url = get_params('redirect_url');
      const targetUrl = `https://b2b.tozostore.com/${redirect_url}` || 'https://b2b.tozostore.com/'; // 默认跳转首页
      formData.set('redirect_url', targetUrl)
      
      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/login',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            get_userinfo(res.data.redirect_url)
            click_set_fun(2)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user_login"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;
  var SavaButton = true;



  $(document).ready(function() {

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }

    // 用户信息
    function get_userinfo(redirect_url){
      const emailNumber = document.querySelector('#email')
      let data = {
        email: emailNumber.value,
      }
      $.ajax({
        url: api_url + 'bshop/userinfo',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          set_login_state_fun(1)
          if(res.code == 0){
            let userinfo = res.data ? JSON.stringify(res.data) : ''
            localStorage.setItem('userinfo', userinfo);
            // 从localStorage中获取
            const storedUserInfo = localStorage.getItem('userinfo');
            // 转为对象（如果存储的不是空字符串）
            const userData = storedUserInfo ? JSON.parse(storedUserInfo) : null;
            window.userData = userData
            if(redirect_url){
              window.location.href = redirect_url; // 同步shopfiy登录态
            }else{
              callback()
            }
            console.log(userData)
          }else{
            error_fun(res, 'error_fun')
          }
          },
        error: function(xhr, status, error) {
          error_fun(error, 'error_fun')
        }
      })
    }

    $('#login-page-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      const redirect_url = get_params('redirect_url');
      const targetUrl = `https://b2b.tozostore.com/${redirect_url}` || 'https://b2b.tozostore.com/'; // 默认跳转首页
      formData.set('redirect_url', targetUrl)
      
      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/login',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            api_err.innerHTML = ''
            get_userinfo(res.data.redirect_url)
            set_login_state_fun(2)
            login_click_set_fun(2)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user_register"] && !Shopify.designMode) return;
  try {
    

  // var api_url = 'https://api.tozostore.com/api/v1/';
  var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Next_text = document.getElementById('Next_text');
  const Submit_text = document.getElementById('Submit_text');
  const Next_img = document.getElementById('Next_img');
  const step1Btn = document.getElementById('step1Btn');
  const step2Btn = document.getElementById('step2Btn');
  var NextButton = true;
  var SavaButton = true;

  // 分步显示逻辑
  let stepFun = function(step){
    if(step == 'basic_information'){
      basic_information.style.display = 'block'
      additional_information.style.display = 'none'
      
      step1Btn.style.display = 'block'
      step2Btn.style.display = 'none'
    }else if(step == 'additional_information'){
      // 切换到第二步前验证第一步必填项
      const requiredFields = [
        document.getElementById('register_confirm_password'),
        document.getElementById('register_password'),
        document.getElementById('register_code'),
        document.getElementById('register_email'),
      ];
      
      let isValid = true;
      requiredFields.forEach(field => {
        if (!field.checkValidity()) {
          field.reportValidity();
          field.focus();
          isValid = false;
        }
      });
      
      if (!isValid) return;
      
      basic_information.style.display = 'none'
      additional_information.style.display = 'block'
      step1Btn.style.display = 'none'
      step2Btn.style.display = 'block'
    }
  }

  Next_text.addEventListener('click', function() {
    stepFun('additional_information')
  })

  Previous_text.addEventListener('click', function() {
    stepFun('basic_information')
  })
  stepFun('basic_information')

  $(document).ready(function() {
    const emailGet = document.querySelector('.email__get')
    const emailNumber = document.querySelector('#register_email')
    const isacc = document.querySelector('#isacc')
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    // const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    let flag = true
    if(emailGet){
      emailGet.addEventListener('click',function() {
        if(!emailNumber.value){
          error_fun('email_required', 'error_text')
          emailNumber.focus(); // 聚焦到邮箱输入框
          return
        }else if (!emailNumber.checkValidity()) {
          emailNumber.reportValidity();
          emailNumber.focus();
          return;
        }else{
          error_fun('', 'error_text')
        }

        let data = {
          email: emailNumber.value,
        }
        if(flag) {
          flag = false
          $.ajax({
          url: api_url + 'bshop/checkregister',
          type: 'post',
          data,
          success: function(res) {
            console.log(res)
            if(res.code == 0){
              flag = true
              if(res.data.is_exist == 0){
                register_error_fun('', 'error_text')
                registeremailcode(data)
              }else{
                register_error_fun('Registered', '')
              }
            }else{
              flag = true
              register_error_fun(res, 'error_fun')
            }
          },
          error: function(xhr, status, error) {
            flag = true
            register_error_fun(error, 'error_fun')
            // form.reset();
          }
        })
        }
      })
    }

    // 获取验证码
    function registeremailcode(data){
      $.ajax({
        url: api_url + 'bshop/registeremailcode',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 0){
            emailGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
            if(time <= 0) {
              clearInterval(countdownInterval)
              emailGet.classList.remove('cursor_no')
              let textContent = get_code_text()
                emailGet.textContent = textContent ? textContent : 'Get Code'
                time = 60
              } else {
                time--
                emailGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            register_error_fun(res, 'error_fun')
          }
          },
        error: function(xhr, status, error) {
          register_error_fun(error, 'error_fun')
        }
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          // dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            // const li = document.createElement("li")
            // li.innerHTML =  `
            //   <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
            //   <span class="ls-select__option-code">${data[i].iso_code}</span>
            // `
            // if(i === 0) {
            //   li.classList.add('select_li')
            // }
            // li.addEventListener('click', function() {
            //   dropdownText.value = `+${data[i].call_prefix}`
            //   dropdownMenu.style.display = 'none'
            //   dropdownIcon.classList.remove('is__reverse')
            //   const prefixs = document.querySelectorAll('.dropdown-menu >li')
            //   removeClass(prefixs,'select_li')
            //   li.classList.add('select_li')
            // })
            // dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              // dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              console.log(country_id)
              console.log(country_iso_code)
              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              // dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            register_error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        register_error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    function form_loding(button, type){
      if(button == 'Next' || button == 'Submit'){
        if(type == 'text'){
          NextButton = true
          Next_img.style.display = 'none'
          if(button == 'Next'){
            Next_text.style.display = 'block'
          }else  if(button == 'Submit'){
            Submit_text.style.display = 'block'
          }
        }else{
          NextButton = false
          Next_img.style.display = 'block'
          if(button == 'Next'){
            Next_text.style.display = 'none'
          }else  if(button == 'Submit'){
            Submit_text.style.display = 'none'
          }
        }
      }
    }
    
    // let product_id = get_params('products_id')
    function get_params(name){
      // 获取当前URL的查询参数
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";  
    }

    $('#registered-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();

      // 验证所有必填字段
      const requiredFields = [
        document.getElementById('register_confirm_password'),
        document.getElementById('register_password'),
        document.getElementById('register_code'),
        document.getElementById('register_email'),
        document.getElementById('company_name'),
        document.getElementById('contact_person'),
        document.getElementById('isacc')
      ];
      
      let isValid = true;
      requiredFields.forEach(field => {
        if (!field.checkValidity()) {
          field.reportValidity();
          field.focus();
          isValid = false;
          return false; // 跳出循环
        }
      });
      
      if (!isValid) return;

      const formData = new FormData(this)
      let isaccValue = isacc.checked
      formData.set('isacc', isaccValue)

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }

      // 1. 处理 business_type：未选择时删除该字段（单选按钮未选中时 FormData 中值为空）
      const businessTypeChecked = document.querySelector('input[name="business_type"]:checked');
      if (!businessTypeChecked) {
        formData.delete('business_type'); // 未选择则删除字段，不提交
      }

      // 2. 强制过滤 platform_name 空值：无论任何情况，空值就删除
      const platformNameVal = formData.get('platform_name')?.toString().trim() || '';
      if (platformNameVal === '') {
        formData.delete('platform_name');
      }
      // 2. 强制过滤 reason_to_cooperate 空值：无论任何情况，空值就删除
      const reasonToCooperateVal = formData.get('reason_to_cooperate')?.toString().trim() || '';
      if (reasonToCooperateVal === '') {
        formData.delete('reason_to_cooperate');
      }

      // 3. 通用过滤：所有字段的空值（兼容其他非必填字段）
      for (let [key, value] of formData.entries()) {
        // 排除 isacc（布尔值，false 也需要提交）
        if (key === 'isacc') continue;
        
        // 空字符串/全空格/null/undefined 都删除
        const strVal = value?.toString().trim() || '';
        if (strVal === '') {
          formData.delete(key);
        }
      }

      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Submit', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/register',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Submit', 'text')
          if(res.code == 0){
            register_click_set_fun(2)
          }else{
            register_error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Submit', 'text')
          register_error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});


  } catch(e) { console.error(e); }
})();
})();
